import Papa from "papaparse";
import { saveAs } from "file-saver";

type Head = { id: string; label: string };

const isCoordinateField = (fieldId: string): boolean => {
  return (
    fieldId.toLowerCase().includes("latitude") ||
    fieldId.toLowerCase().includes("longitude")
  );
};

export function formatCSVData<T>(
  data: T[],
  heads: Head[],
): Record<string, unknown>[] {
  return data.map((item) => {
    const formattedItem: Record<string, unknown> = {};

    heads.forEach((head) => {
      const value = item[head.id as keyof T];

      if (value && typeof value === "object" && !Array.isArray(value)) {
        Object.entries(value).forEach(([subKey, subValue]) => {
          formattedItem[`${head.id}.${subKey}`] = subValue;
        });
      } else {
        const formattedValue =
          typeof value === "number" && isCoordinateField(head.id)
            ? `="${value}"`
            : value;

        formattedItem[head.label] = formattedValue;
      }
    });

    return formattedItem;
  });
}

export function exportToCSV(
  formattedData: Record<string, unknown>[],
  filename: string,
) {
  if (!formattedData?.length) {
    throw new Error("Nenhum dado para exportar");
  }

  const csv = Papa.unparse(formattedData, { delimiter: ";" });
  const utf8BOM = "\uFEFF";
  const blob = new Blob([utf8BOM + csv], {
    type: "text/csv;charset=utf-8;",
  });
  saveAs(blob, `${filename}.csv`);
}
